import 'velocity-animate';
import $ from 'jquery';

import config from './globals/config';
import videoEvents from './video-events';
import trailerDrawerRotation from './trailer-drawer-rotation';

export default function (
  handle,
  playerLightbox,
  innerWrap,
  headerContainer,
  leftOffCanvasMenu,
  trailerDrawerBG,
  trailerDrawerTitle,
  trailerDrawerInfoTitle,
  trailerDrawerDesktop,
  leftTrailer,
  rightTrailer
) {

  let myPlayerEvents = new videoEvents(config.myPlayer);

  handle.removeClass('close');

  $('.drawer-bg').css('opacity', 0);

  playerLightbox.velocity('player-lightbox-hide', {
    complete: function () {
      $('.vjs-social-cancel', playerLightbox).click();

      myPlayerEvents.stopVideoPlayer();
    },
  });

  innerWrap.velocity({ left: 0 }, {
    duration: config.drawerSlideTiming,
    easing  : config.easing,
    complete: function () {
      headerContainer.velocity({
        right: 0,
        left : '7.48em',
      });

      if ( config.isiPad || config.isAndroid ) {
        $('.exit-off-canvas').velocity({ opacity: 0 }, { duration: 300 });
      }

      $('.drawer-info-container .drawer-info').velocity({ opacity: 1 }, { duration: 300, display: 'block' });
      $('.drawer-info-container').velocity({ 'margin-left': '-26.7em' }, { duration: 300 });

      config.trailerDrawerIsRotating = true;

      trailerDrawerBG.velocity({ translateX: 0 }, {
        duration: 0,
        complete: function () {
          config.trailerDrawerIsAnimating = false;

          trailerDrawerRotation(
            trailerDrawerBG,
            trailerDrawerTitle,
            trailerDrawerInfoTitle,
            trailerDrawerDesktop,
            leftTrailer,
            rightTrailer
          );
        },
      });
    },
  });

  handle.velocity({
    left: 0,
  }, {
    duration: config.drawerSlideTiming,
    easing  : config.easing,
  });

  leftOffCanvasMenu.velocity({
    left : '-23.78em',
    width: '500px',
  }, {
    duration: config.drawerSlideTiming,
    easing  : config.easing,
  });
}
